import React from "react";
import { api, dmyToSlash } from "../../services/api";

const cellInput =
  "w-full px-3 py-2.5 rounded-md border border-gray-300 outline-none focus:border-[#3f6fb5] focus:ring-2 focus:ring-[#3f6fb5]/30 text-lg text-gray-700";

export default function CommonNumberAdmin({ onAuthError }) {
  const [form, setForm] = React.useState({
    dateObj: "",
    fr: { direct: "", house: "", ending: "" },
    sr: { direct: "", house: "", ending: "" },
  });
  const [success, setSuccess] = React.useState(false);
  const [err, setErr] = React.useState("");
  const [saving, setSaving] = React.useState(false);

  React.useEffect(() => {
    api.commonNumber().then((c) => {
      if (c) setForm({ dateObj: c.dateObj, fr: c.fr, sr: c.sr });
    });
  }, []);

  const setRound = (round, field, val) =>
    setForm((f) => ({ ...f, [round]: { ...f[round], [field]: val } }));

  const save = async (e) => {
    e.preventDefault();
    setSuccess(false);
    setErr("");
    if (!form.dateObj) return setErr("Please select a date");
    setSaving(true);
    try {
      await api.upsertCommonNumber(form);
      setSuccess(true);
    } catch (e2) {
      if (e2?.response?.status === 401) onAuthError();
      else setErr("Error saving");
    } finally {
      setSaving(false);
    }
  };

  return (
    <form
      onSubmit={save}
      className="bg-white rounded-2xl border-2 border-dashed border-[#8fd3c9] p-5 sm:p-7"
    >
      <h3 className="font-black tracking-wide text-[#1f2733] text-xl sm:text-2xl uppercase mb-4">
        Update Common Number
      </h3>

      {success && (
        <div className="bg-[#2c4a5e] text-white rounded-lg px-5 py-4 text-lg font-semibold mb-6">
          Common Number Added Successfully
        </div>
      )}
      {err && (
        <div className="bg-red-50 text-red-600 rounded-lg px-4 py-2.5 text-sm font-semibold mb-5">
          {err}
        </div>
      )}

      <div className="border-t border-gray-100 pt-5">
        <label className="block text-gray-500 font-semibold mb-2">Select Date:</label>
        <input
          type="date"
          value={form.dateObj}
          onChange={(e) => setForm({ ...form, dateObj: e.target.value })}
          className="w-full max-w-md px-4 py-3 rounded-md border border-gray-300 outline-none focus:border-[#3f6fb5] focus:ring-2 focus:ring-[#3f6fb5]/30 text-lg text-gray-700 mb-6"
        />
        {form.dateObj && (
          <p className="-mt-4 mb-6 text-sm text-gray-400">
            Selected: {dmyToSlash(form.dateObj.split("-").reverse().join("-"))}
          </p>
        )}

        {/* Direct / House / Ending table */}
        <div className="grid grid-cols-3 border-t border-l border-gray-200 rounded-md overflow-hidden">
          {["Direct", "House", "Ending"].map((h) => (
            <div key={h} className="border-r border-b border-gray-200 px-4 py-3 font-bold text-gray-500 text-lg">
              {h}
            </div>
          ))}
          {/* First Round */}
          <div className="border-r border-b border-gray-200 p-3">
            <input value={form.fr.direct} onChange={(e) => setRound("fr", "direct", e.target.value)} className={cellInput} placeholder="15,04" />
          </div>
          <div className="border-r border-b border-gray-200 p-3">
            <input value={form.fr.house} onChange={(e) => setRound("fr", "house", e.target.value)} className={cellInput} placeholder="7" />
          </div>
          <div className="border-r border-b border-gray-200 p-3">
            <input value={form.fr.ending} onChange={(e) => setRound("fr", "ending", e.target.value)} className={cellInput} placeholder="1" />
          </div>
          {/* Second Round */}
          <div className="border-r border-b border-gray-200 p-3">
            <input value={form.sr.direct} onChange={(e) => setRound("sr", "direct", e.target.value)} className={cellInput} placeholder="38" />
          </div>
          <div className="border-r border-b border-gray-200 p-3">
            <input value={form.sr.house} onChange={(e) => setRound("sr", "house", e.target.value)} className={cellInput} placeholder="8" />
          </div>
          <div className="border-r border-b border-gray-200 p-3">
            <input value={form.sr.ending} onChange={(e) => setRound("sr", "ending", e.target.value)} className={cellInput} placeholder="6" />
          </div>
        </div>

        <div className="flex justify-center mt-7">
          <button
            disabled={saving}
            className="px-10 py-3 rounded-lg bg-[#3f6fb5] hover:bg-[#345c96] text-white font-bold text-lg transition-colors disabled:opacity-60"
          >
            {saving ? "Submitting..." : "Submit"}
          </button>
        </div>
      </div>
    </form>
  );
}
